<template>
 <div>
    <v-btn @click="openGallery" color="accent" icon><v-icon>$gallery</v-icon></v-btn>
    <v-dialog scrollable width="700" v-model="openModal">
      <v-card>
        <v-card-title class="headline">{{$t('galleryedit_choose_gallery')}}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col @click="selectPicture(image)" cols="4" v-for="image in images" :key="image">
              <img :class="{ 'selected': selectedPicture == image }" :src="image" >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <div v-if="!isAvailable(`editor.tabs.tools.image`)">
            <iframe-link link="/#/upgrade" :content="$t('galleryedit_upgrade_today')"></iframe-link> {{$t('galleryedit_add_own_pictures')}}
          </div>
          <div v-if="isAvailable(`editor.tabs.tools.image`)" v-html="$t('galleryedit_upload_tips')">
          </div>
          <v-spacer></v-spacer>
          <v-btn text @click="close">{{$t('close')}}</v-btn>
          <v-btn text @click="save" color="primary">{{$t('save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import IframeLink from '@/components/utils/IframeLink'
import { mapGetters } from 'vuex'

export default {
  name: 'GalleryEdit',
  components: {
    IframeLink
  },
  computed: {
    ...mapGetters(['isAvailable'])
  },
  props: ['image'],
  data () {
    return {
      openModal: false,
      selectedPicture: '',
      images: [
        'https://s3-eu-west-1.amazonaws.com/cc-staging.scantrust.com/c/5994/stcfile/blob-xtjnzx',
        'https://s3-eu-west-1.amazonaws.com/cc-staging.scantrust.com/c/5994/stcfile/blob-xefgvt',
        'https://s3-eu-west-1.amazonaws.com/cc-staging.scantrust.com/c/5994/stcfile/blob-vuilce'
      ]
    }
  },
  methods: {
    openGallery () {
      this.openModal = true
    },

    close () {
      this.openModal = false
    },

    selectPicture (picture) {
      this.selectedPicture = picture
    },

    save () {
      this.$emit('image-selected', this.selectedPicture)
      this.close()
    }
  },
  create () {
    if (this.image) {
      this.selectedPicture = this.image
    }
  }
}

</script>

<style lang="sass" scoped>

@import '@/variables.sass'

img
  width: 100%
  opacity: 0.5
  &.selected
    opacity: 1
    border: solid 2px rgba(var(--primary))

</style>
